import { Box } from "@mui/material";

import { ActivePatientStat, ProductSplitBar } from "../bars";
import {
  EmptyPanelMessage,
  NestedPanel,
  SectionTitleRow,
} from "../primitives";
import { BORDER, LEFT_PANEL_MIN_HEIGHT } from "../tokens";

export default function ActivePatientsQtdPanel({
  activePatients,
  activePatientSplits,
  onExplore,
}) {
  return (
    <NestedPanel
      sx={{
        minHeight: LEFT_PANEL_MIN_HEIGHT,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SectionTitleRow label="Active Patients QTD" onExplore={onExplore} />
      {/* Stats stay anchored at the top, directly below the title. */}
      {activePatients.length > 0 ? (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {activePatients.map((stat, index) => (
            <ActivePatientStat key={stat.product || index} stat={stat} />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <EmptyPanelMessage>No insights found</EmptyPanelMessage>
        </Box>
      )}
      {activePatientSplits.length > 0 && (
        <Box
          sx={{
            flex: 1,
            mt: 2,
            pt: 2,
            borderTop: `1px solid ${BORDER}`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {activePatientSplits.map((split) => (
            <ProductSplitBar key={split.label} split={split} />
          ))}
        </Box>
      )}
    </NestedPanel>
  );
}
